<template>
  <div class="modal-content">
    <div class="modal-body">
      <route-details :value="selectedRoute" :categories="categories" :products="products" :templates="templates" v-on:input="save" v-on:close="hideModal" />
    </div>
  </div>
</template>

<script>

import RouteDetails from '~/components/RouteDetails'

export default {
  props: ['selectedRoute', 'categories', 'products', 'templates'],
  methods: {
    hideModal () {
      this.$emit('close')
    },
    save (route) {
      this.$emit('save', route)
    }
  },
  components: {
    RouteDetails
  }
}

</script>